/* Crowné theme scripts: cart drawer, AJAX cart, variant picker, UI niceties. */
(function () {
  "use strict";

  var settings = window.Crowne || {};
  var routes = settings.routes || {};
  var strings = settings.strings || {};

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    var fmt = settings.moneyFormat || "R{{amount}}";
    var withDecimals = fmt.replace(/\{\{\s*amount\s*\}\}/, amount);
    var noDecimals = withDecimals.replace(
      /\{\{\s*amount_no_decimals\s*\}\}/,
      Math.round(cents / 100).toString()
    );
    return noDecimals.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount);
  }

  /* ---------- Toast ---------- */
  var toastEl = document.getElementById("CrowneToast");
  var toastTimer;
  function toast(message) {
    if (!toastEl) return;
    toastEl.textContent = message;
    toastEl.hidden = false;
    toastEl.classList.add("is-visible");
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toastEl.classList.remove("is-visible");
      toastEl.hidden = true;
    }, 2600);
  }

  /* ---------- Cart drawer ---------- */
  var drawer = document.getElementById("CartDrawer");
  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add("is-open");
    drawer.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove("is-open");
    drawer.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
  }
  document.addEventListener("click", function (e) {
    var opener = e.target.closest("[data-open-drawer]");
    if (opener && drawer) {
      e.preventDefault();
      openDrawer();
      return;
    }
    if (e.target.closest("[data-close-drawer]")) {
      e.preventDefault();
      closeDrawer();
    }
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") closeDrawer();
  });

  function updateCartCount(count) {
    document.querySelectorAll("[data-cart-count]").forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  function lineOptions(item) {
    var opts = (item.options_with_values || [])
      .filter(function (o) { return o.value && o.value !== "Default Title"; })
      .map(function (o) { return o.value; });
    return opts.join(" / ");
  }

  function lineImage(item) {
    if (item.featured_image && item.featured_image.url) return item.featured_image.url;
    return null;
  }

  function renderCart(cart) {
    updateCartCount(cart.item_count);

    var subtotalEls = document.querySelectorAll("[data-cart-subtotal]");
    subtotalEls.forEach(function (el) { el.textContent = formatMoney(cart.total_price); });

    if (!drawer) return;
    var wrap = drawer.querySelector("[data-cart-items]");
    if (!wrap) return;
    var html = "";
    if (cart.item_count === 0) {
      html = '<p class="cart-drawer-empty">Your cart is empty</p>';
    } else {
      cart.items.forEach(function (item) {
        var img = lineImage(item);
        var variant = lineOptions(item);
        html +=
          '<div class="cart-drawer-line" data-line-key="' + item.key + '">' +
            '<div class="cart-drawer-line-media">' +
              (img ? '<img src="' + img + '" alt="" width="80" height="80" loading="lazy">' : "") +
            "</div>" +
            '<div class="cart-drawer-line-info">' +
              '<p class="cart-drawer-line-title">' + item.product_title + "</p>" +
              (variant ? '<p class="cart-drawer-line-variant">' + variant + "</p>" : "") +
              '<p class="cart-drawer-line-price">' + formatMoney(item.final_price) + "</p>" +
              '<div class="cart-drawer-line-qty">' +
                '<button type="button" class="qty-btn" data-drawer-qty="-1" aria-label="Decrease quantity">&minus;</button>' +
                '<span class="qty-value">' + item.quantity + "</span>" +
                '<button type="button" class="qty-btn" data-drawer-qty="1" aria-label="Increase quantity">+</button>' +
              "</div>" +
            "</div>" +
          "</div>";
      });
    }
    wrap.innerHTML = html;
  }

  function fetchCart(callback) {
    fetch((routes.cart || "/cart") + ".js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(callback)
      .catch(function () {});
  }

  function changeLine(key, quantity) {
    fetch(routes.cartChange || "/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); })
      .catch(function () { toast(strings.cartError || "Something went wrong."); });
  }

  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-drawer-qty]");
    if (!btn || !drawer) return;
    var line = btn.closest("[data-line-key]");
    if (!line) return;
    var delta = parseInt(btn.getAttribute("data-drawer-qty"), 10);
    var qtyEl = line.querySelector(".qty-value");
    var current = parseInt(qtyEl.textContent, 10) || 1;
    var next = current + delta;
    if (next < 0) next = 0;
    if (next === current) return;
    qtyEl.textContent = next;
    changeLine(line.getAttribute("data-line-key"), next);
  });

  /* ---------- AJAX add to cart ---------- */
  function addToCart(formData, button) {
    if (button) {
      button.disabled = true;
      button.dataset.originalText = button.textContent;
      button.textContent = "Adding…";
    }
    fetch(routes.cartAdd || "/cart/add.js", {
      method: "POST",
      headers: { Accept: "application/json" },
      body: formData
    })
      .then(function (r) {
        if (!r.ok) throw new Error("add failed");
        return r.json();
      })
      .then(function () {
        fetchCart(function (cart) {
          renderCart(cart);
          openDrawer();
        });
        toast(strings.addedToCart || "Added to your cart");
      })
      .catch(function () {
        toast(strings.cartError || "Something went wrong. Please try again.");
      })
      .finally(function () {
        if (button) {
          button.disabled = false;
          button.textContent = button.dataset.originalText || "Add to cart";
        }
      });
  }

  document.addEventListener("submit", function (e) {
    var form = e.target.closest("[data-quick-add]");
    if (!form) return;
    e.preventDefault();
    addToCart(new FormData(form), form.querySelector("button[type=submit]"));
  });

  /* ---------- Product page ---------- */
  var productSection = document.querySelector("[data-product-section]");
  if (productSection) {
    var variants = [];
    var variantsEl = productSection.querySelector("[data-variants-json]");
    if (variantsEl) {
      try { variants = JSON.parse(variantsEl.textContent); } catch (err) { variants = []; }
    }
    var selects = Array.prototype.slice.call(
      productSection.querySelectorAll(".variant-select")
    );
    var idInput = productSection.querySelector("[data-variant-id]");
    var priceWrap = productSection.querySelector("[data-product-price]");
    var availability = productSection.querySelector("[data-availability]");
    var addBtn = productSection.querySelector("[data-add-to-cart]");
    var buyBtn = productSection.querySelector("[data-buy-now]");

    function currentSelection() {
      return selects.map(function (s) { return s.value; });
    }

    function findVariant() {
      if (!selects.length) return variants[0] || null;
      var sel = currentSelection();
      return (
        variants.filter(function (v) {
          for (var i = 0; i < sel.length; i++) {
            if (v["option" + (i + 1)] !== sel[i]) return false;
          }
          return true;
        })[0] || null
      );
    }

    function updateProduct() {
      var variant = findVariant();
      if (!variant) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = strings.unavailable || "Unavailable"; }
        if (buyBtn) buyBtn.disabled = true;
        if (availability) availability.textContent = strings.unavailable || "Unavailable";
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (priceWrap) {
        var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        priceWrap.innerHTML =
          '<span class="price' + (onSale ? " price-sale" : "") + '">' + formatMoney(variant.price) + "</span>" +
          (onSale ? '<s class="price-compare">' + formatMoney(variant.compare_at_price) + '</s><span class="badge badge-sale">Sale</span>' : "");
      }
      var soldOut = !variant.available;
      if (availability) availability.textContent = soldOut ? (strings.soldOut || "Sold out") : "In stock";
      if (addBtn) { addBtn.disabled = soldOut; addBtn.textContent = soldOut ? (strings.soldOut || "Sold out") : "Add to cart"; }
      if (buyBtn) buyBtn.disabled = soldOut;
      if (variant.featured_image && variant.featured_image.src) {
        var mainImg = document.getElementById("ProductMainImage");
        if (mainImg) mainImg.src = variant.featured_image.src;
      }
    }

    selects.forEach(function (s) { s.addEventListener("change", updateProduct); });

    /* Quantity */
    var qtyValue = productSection.querySelector("[data-qty-value]");
    var qtyInput = productSection.querySelector("[data-quantity-input]");
    productSection.addEventListener("click", function (e) {
      var btn = e.target.closest("[data-qty]");
      if (!btn || !qtyValue || !qtyInput) return;
      var next = Math.max(1, (parseInt(qtyValue.textContent, 10) || 1) + parseInt(btn.getAttribute("data-qty"), 10));
      qtyValue.textContent = next;
      qtyInput.value = next;
    });

    /* Gallery thumbs */
    productSection.addEventListener("click", function (e) {
      var thumb = e.target.closest("[data-thumb-src]");
      if (!thumb) return;
      var mainImg = document.getElementById("ProductMainImage");
      if (mainImg) mainImg.src = thumb.getAttribute("data-thumb-src");
      productSection.querySelectorAll(".product-thumb").forEach(function (t) {
        t.classList.toggle("is-active", t === thumb);
      });
    });

    /* Add to cart (AJAX) */
    if (addBtn) {
      addBtn.addEventListener("click", function () {
        var form = productSection.querySelector("[data-product-form]");
        if (!form || !idInput || !idInput.value) return;
        var fd = new FormData();
        fd.append("id", idInput.value);
        fd.append("quantity", qtyInput ? qtyInput.value : "1");
        addToCart(fd, addBtn);
      });
    }

    /* Buy now — submit form to /cart/add with return_to /checkout */
    var returnTo = productSection.querySelector("[data-return-to]");
    if (buyBtn && returnTo) {
      buyBtn.addEventListener("click", function () {
        returnTo.value = routes.checkout || "/checkout";
        var form = productSection.querySelector("[data-product-form]");
        if (form) form.submit();
      });
    }
  }

  /* ---------- Mobile menu ---------- */
  document.addEventListener("click", function (e) {
    var toggle = e.target.closest("[data-menu-toggle]");
    if (!toggle) return;
    var nav = document.getElementById(toggle.getAttribute("aria-controls"));
    if (!nav) return;
    var open = nav.hidden;
    nav.hidden = !open;
    toggle.setAttribute("aria-expanded", open ? "true" : "false");
  });

  /* ---------- Fade-up on scroll ---------- */
  var fadeEls = document.querySelectorAll(".fade-up");
  if ("IntersectionObserver" in window && fadeEls.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    fadeEls.forEach(function (el) { io.observe(el); });
  } else {
    fadeEls.forEach(function (el) { el.classList.add("is-visible"); });
  }
})();
